// extracted by mini-css-extract-plugin
module.exports = {"typing":"BxoBzCBVdPnEvJ_RAkRxH"};